import { DeviceEventEmitter } from 'react-native';

export const MODAL_EVENTS = {
  CLOSE_ALL_MODALS: 'CLOSE_ALL_MODALS',
  SHOW_GAMIFICATION_INTRO: 'SHOW_GAMIFICATION_INTRO',
  RESET_HOMEPAGE: 'RESET_HOMEPAGE',
} as const;

export const modalEvents = {
  emitCloseAllModals: () => {
    DeviceEventEmitter.emit(MODAL_EVENTS.CLOSE_ALL_MODALS);
  },

  onCloseAllModals: (callback: () => void) => {
    return DeviceEventEmitter.addListener(MODAL_EVENTS.CLOSE_ALL_MODALS, callback);
  },

  emitShowGamificationIntro: () => {
    DeviceEventEmitter.emit(MODAL_EVENTS.SHOW_GAMIFICATION_INTRO);
  },

  onShowGamificationIntro: (callback: () => void) => {
    return DeviceEventEmitter.addListener(MODAL_EVENTS.SHOW_GAMIFICATION_INTRO, callback);
  },

  emitResetHomepage: () => {
    DeviceEventEmitter.emit(MODAL_EVENTS.RESET_HOMEPAGE);
  },

  onResetHomepage: (callback: () => void) => {
    return DeviceEventEmitter.addListener(MODAL_EVENTS.RESET_HOMEPAGE, callback);
  },
};
